import React from "react"
import { Link } from "gatsby"

const locales = require("../../../config/i18n")

const LangSwitcher = ({ locale, alternates = [] }) => {
	const nav = Object.values(locales).map(loc => {
		const alt = alternates.find(a => a.lang === loc.locale)
		const url = alt ? alt.path : (loc.default ? "/" : `/${loc.path}`)
		return {
			url,
			label: loc.label,
			locale: loc.locale,
		}
	})

	return (
		<ul className="language-switcher">
			{nav.map((li, key) => {
				const _liClassName = li.locale === locale ? "active" : ""
				return (
					<li key={key} className={`${_liClassName} fL`}>
						<Link className={_liClassName + " "} to={li.url}>
							{li.label}
						</Link>
					</li>
				)
			})}
		</ul>
	)
}

export default LangSwitcher
